import {Injectable} from '@angular/core';
import {AmdocsAppsyncClientService} from 'amdocs-core-package';
import {BehaviorSubject, Observable, of} from 'rxjs';
import {catchError, mergeMap} from 'rxjs/operators';
import { CONSTANTS } from '../constants';


@Injectable()
export class InitService {
  private responseProductMeteData: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  constructor( private appSyncClient: AmdocsAppsyncClientService) {
  } 

  getProductLineMetaData(apsSupportOneRequest,sessionContextInput?): Observable<any> {
    const initQuery = `query GetProductLineMetaData($apsSupportOneRequest: ApsSupportOneRequestInput!,$sessionContextInput:SessionContextInput ) {
      getProductLineMetaData(apsSupportOneRequest: $apsSupportOneRequest, sessionContextInput: $sessionContextInput) {
        Classic {
                Category
                values {
                  SysID
                  isMarkFavourite
                  name
                }
              }
              Rapid {
                Category
                values {
                  SysID
                  isMarkFavourite
                  name
                }
              }
              params {
                Dac_SessionID
                ErrorDesc
                IsEligible
                SO_SessionID
                UPN
                User_ID
              }
    }
    }
  `;
    const paramsvalues = {apsSupportOneRequest, sessionContextInput};
    return this.appSyncClient.call(initQuery, 'GetProductLineMetaData', paramsvalues).pipe(
        mergeMap( (res: any): Observable<any> => {
          this.responseProductMeteData.next(res);
          let isUserEligible=res?.['getProductLineMetaData']?.['params']?.['IsEligible'];
          if(isUserEligible){
            // localStorage.setItem(CONSTANTS.STORAGE.productLines, JSON.stringify(res?.['getProductLineMetaData']));
          }

          return of(res);
        }),
        catchError( err => {
          console.log(err);
          return of({error: err});
        })
    );
  }

  getProductLineResponseData(): Observable<any> {
    return this.responseProductMeteData.asObservable();
  }


}
